import React, { useState, useEffect } from 'react';
import LoginForm from '../components/LoginForm';
import ProductEditor from '../components/ProductEditor';
import FeaturedEditor from '../components/FeaturedEditor';
import styled from 'styled-components';

const AdminContainer = styled.div`
  max-width: 1100px;
  margin: 40px auto;
  padding: 0 20px 40px;
  color: var(--text);
`;

const Section = styled.section`
  margin-top: 32px;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
`;

const SectionTitle = styled.h2`
  color: var(--accent);
  margin-bottom: 12px;
  font-size: 1.5rem;
`;

export default function AdminPage() {
  const [token, setToken] = useState(localStorage.getItem('jwt'));

  if (!token) {
    return (
      <LoginForm
        onAuth={(t) => {
          localStorage.setItem('jwt', t);
          setToken(t);
        }}
      />
    );
  }

  return (
    <AdminContainer>
      <h1 style={{ color: 'var(--accent)' }}>Admin</h1>
      <button
        style={{
          padding: '8px 12px',
          borderRadius: 20,
          border: '1px solid var(--accent)',
          background: 'transparent',
          color: 'var(--accent)',
          fontWeight: 700,
          cursor: 'pointer',
        }}
        onClick={() => {
          localStorage.removeItem('jwt');
          setToken(null);
        }}
      >
        Log out
      </button>

      <Section>
        <SectionTitle>Manage Products</SectionTitle>
        <ProductList token={token} />
        <ProductEditor token={token} onChange={() => {}} />
      </Section>

      <Section>
        <SectionTitle>Featured Settings</SectionTitle>
        <FeaturedEditor token={token} />
      </Section>
    </AdminContainer>
  );
}

function ProductList({ token }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const reload = () => {
    setLoading(true);
    fetch('/api/admin/products', { headers: { Authorization: 'Bearer ' + token } })
      .then((r) => r.json().then((d) => ({ ok: r.ok, d })))
      .then(({ ok, d }) => {
        if (!ok) throw new Error(d.message || 'Failed to load products');
        setItems(Array.isArray(d) ? d : []);
      })
      .catch((e) => setError(e.message || 'Failed to load products'))
      .finally(() => setLoading(false));
  };
  useEffect(reload, [token]);

  if (loading) return <div style={{ color: 'var(--muted)' }}>Loading…</div>;
  if (error) return <div style={{ color: '#b91c1c' }}>{error}</div>;

  return (
    <div>
      {items.map((p) => (
        <ProductEditor key={p.id} token={token} product={p} onChange={reload} />
      ))}
    </div>
  );
}

